var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('@truqc/content-path'),
  getContentValue = _require.getContentValue;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
 * Provides the Pass Type options
 * (under the Add Pass button in the Weld Passes section)
 * according to which WPS is selected in the General section.
 *
 * @function evalute - evaluate ucbWeldPassTypeOptionsBehavior
 */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const weldPassType = getContentValue('/general/weldPassType', content) || {};
  const _Object$keys = Object.keys(weldPassType),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    uuid = _Object$keys2[0];
  const formQuery = {
    type: 'getFormContentBehavior',
    entityName: 'Form',
    uuid
  };
  const formContent = await sourceEvaluator(formQuery);
  const presets = getContentValue('/general/presets', formContent) || {};
  const weldPasses = getContentValue('/weldPasses', content) || {};
  Object.keys(weldPasses).forEach(key => {
    if (presets[key] !== undefined) {
      delete presets[key];
    }
  });
  return {
    title: 'Pass Types',
    options: presets,
    placeholder: 'Please add further Pass Types in the Admin area.'
  };
};
module.exports = {
  evaluate
};